export default __webpack_public_path__ + "static/media/green-tick-icon.d42290e3.svg";